<template>
  <div>
    <QS-h4-title v-if="mode === 'view'" title="司管信息" />
    <QS-h4-title v-else title="司管信息录入" />
    <div v-if="showSave" class="blueBackView">
      操作说明：1.选择对应司管信息后，点击【保存】按钮保存
      2.如需编辑司管信息，请点击【公司】-【人员管理】进行编辑
    </div>
    <el-form class="dm-form">
      <el-form-item label="司管头像:">
        <EnlargeImg
          v-if="selectDm.avatar"
          :imgSrc="selectDm.avatar"
        ></EnlargeImg>
        <span v-else>-</span>
      </el-form-item>
      <el-form-item label="">
        <el-form :inline="true">
          <el-form-item label="司管姓名:">
            <template v-if="mode === 'edit'">
              <el-select
                class="dm-p-top"
                v-model="selectDm.id"
                :loading="loading"
                clearable
                remote
                filterable
                placeholder="请选择司管人员"
                :remote-method="searchDm"
                @change="changeSelectDm"
                @clear="searchDm('')"
              >
                <el-option
                  v-for="item in dmList"
                  :key="item.id"
                  :label="item.userName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span
                :class="addDeptStaffAuth ? 'dm-link' : 'sm-link'"
                @click="toAccount"
                >{{ tipText }}</span
              >
            </template>
            <span class="dm-p-top" v-else>{{ selectDm.userName || '-' }}</span>
          </el-form-item>
          <el-form-item label="司管手机:">
            <span class="dm-p-top">{{ selectDm.userMobile || '-' }}</span>
          </el-form-item>
        </el-form>
      </el-form-item>
      <el-form-item v-if="showSave" label=" ">
        <el-button type="primary" @click="saveDm">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getAllEmployeeList } from '@/api/carManage/index.js'
import {
  checkDriverManagerByOrder,
  modifyDriverManager,
} from '@/api/domain/orders'

const MODE = {
  Edit: 'edit',
  View: 'view',
}

export default {
  name: 'DriverManager',
  props: {
    dm: {
      type: Object,
    },
    // 模式
    mode: {
      type: String,
      default: MODE.View,
    },
    // 是否展示保存按钮
    showSave: {
      type: Boolean,
      default: false,
    },
    // 订单 ID，在订单编辑页面才需要传入 orderID 用于校验和保存
    orderId: {},
  },
  data() {
    return {
      selectDm: {
        // 选择的司管ID
        id: null,
        // 司管姓名
        userName: '',
        // 司管手机
        userMobile: null,
        // 司管头像
        avatar: null,
      },
      // 司管列表
      dmList: [],
      loading: false,
    }
  },
  watch: {
    dm: {
      handler(newVal) {
        this.selectDm.id = newVal?.id
        this.selectDm.userMobile = newVal?.userMobile
        this.selectDm.userName = newVal?.userName
        this.selectDm.avatar = this.getURL({ data: newVal?.avatar })
      },
      immediate: true,
    },
  },
  computed: {
    addDeptStaffAuth() {
      return this.judgePermission('add_dept_staff')
    },
    tipText() {
      return this.addDeptStaffAuth
        ? '找不到司管? 点击新增'
        : '（若找不到账号请联系管理员进行添加）'
    },
  },
  methods: {
    changeSelectDm() {
      const selectDm = this.dmList.find((item) => item.id === this.selectDm.id)
      this.selectDm.userMobile = selectDm?.userMobile
      this.selectDm.userName = selectDm?.userName
      this.selectDm.avatar = this.getURL({ data: selectDm?.avatar })
    },
    // 模糊搜索
    searchDm(query) {
      if (!this.loading) {
        this.loading = true
        getAllEmployeeList({ userName: query })
          .then((res) => {
            if (res.code === 1) {
              this.dmList = res.data
            }
            this.loading = false
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    // 点击保存
    saveDm() {
      if (!this.selectDm.id) {
        this.$message.warning('请选择司管')
        return
      }
      // 司管ID有变化则需要校验提示
      this.validateDm(this.selectDm.id)
    },
    // 校验司管是否前后一致
    async validateDm(dmId) {
      const res = await checkDriverManagerByOrder(this.orderId, dmId)
      // 前后司管不一致，需要弹窗让用户确认
      if (res?.code !== 1) {
        return
      }
      if (!res?.data?.pass) {
        this.$confirm(res?.data?.failMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
        }).then(() => {
          this.modifyDm()
        }).catch(() => null)
      } else {
        this.modifyDm()
      }
    },
    // 保存司管
    modifyDm() {
      modifyDriverManager(this.orderId, this.selectDm.id).then((res) => {
        if (res?.code === 1) {
          this.$message.info('保存成功')
        }
      })
    },
    // 跳转到账号管理
    toAccount() {
      if (!this.judgePermission('add_dept_staff')) return
      window.open('/organize/department')
    },
  },
  mounted() {
    if (this.mode === MODE.Edit) {
      this.searchDm('')
    }
  },
}
</script>
<style scoped>
.blueBackView {
  background-color: #ecf3ff;
  color: #006af5;
  padding: 10px 10px 10px 10px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.dm-p-top {
  padding-top: 2px;
  display: inline-block;
}
.dm-link {
  display: inline-block;
  color: #006af5;
  margin-left: 8px;
  cursor: pointer;
}
.sm-link {
  display: inline-block;
  margin-left: 8px;
}
.dm-link {
  display: inline-block;
  color: #006af5;
  margin-left: 8px;
}
</style>
